/* eslint-disable no-magic-numbers */
import React, { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { IAppState } from "store/app-state";
import { fetchHome } from "store/home/home-action";
import {
  NewCreators,
  TopGifs,
  TrendingCreators,
  TrendingGifs,
  TrendingImages,
  TrendingNiches,
  TrendingTags
} from "components/widgets";
import { WithSideAds } from "components/ads";

import "./ExplorePage.scss";
import "../common.scss";
import "../../App.scss";
import { className } from "utils/strings";
import { useDeviceType } from "hooks";
import { ContentPageSkyscraperEnum } from "../../components/ads/config/units/contentPageSkyscraper";
import { FooterAds } from "../../components/ads/FooterAds";

export const ExplorePage = () => {
  const homeGifs = useSelector((state: IAppState) => state.home.homeGifs);
  const homeGifsLoading = useSelector((state: IAppState) => state.home.loading);
  const deviceType = useDeviceType();

  const dispatch = useDispatch();

  useEffect(() => {
    if (!homeGifs.hotCreators?.length && !homeGifsLoading) {
      dispatch(fetchHome());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [homeGifs]);

  return (
    <Fragment>
      <WithSideAds
        leftAds={[
          ContentPageSkyscraperEnum.ContentPageSkyscraperL1,
          ContentPageSkyscraperEnum.ContentPageSkyscraperL2,
          ContentPageSkyscraperEnum.ContentPageSkyscraperL3,
        ]}
        rightAds={[
          ContentPageSkyscraperEnum.ContentPageSkyscraperR1,
          ContentPageSkyscraperEnum.ContentPageSkyscraperR2,
          ContentPageSkyscraperEnum.ContentPageSkyscraperR3,
        ]}
      >
        <div className={className({
          "explorePage": true,
          "narrow page": true,
          [deviceType]: true,
        })}>
          <TopGifs />
          <TrendingNiches />
          <NewCreators />
          <TrendingImages />
          <TrendingCreators list={true} />
          <TrendingGifs />
          <TrendingTags />
        </div>
      </WithSideAds>

      <FooterAds/>
    </Fragment>
  );
};
